<template>
  <div class="login-div" data-vis-target="login-form">
    <form  class="login" data-session="sign-in" @submit.prevent="$parent.inquerySubmit">
      <h4 id="login-title" class="text-center" style="">{{ $t("inquiry") }}</h4>
      <div style="display: none;" class="input-field">
        <input type="hidden" class="hidden form-control" name="type" value="login" required="required">
      </div>
      <div :title="$t('nat_no')" class="input-field d-inline-flex w-100">
        <label class="icon-label" for="NationNo"><font-awesome-icon :icon="['fas', 'user']" /></label>
        <input id="nation-no" type="text" class="form-control" v-model="formFields.nationNo" :placeholder="'الرقم الوطني أو رقم التسجيل'"  required="required">
      </div>
      <div :title="$t('reg_no')" class="input-field d-inline-flex w-100">
        <label class="icon-label" for="CheckNo"><font-awesome-icon :icon="['fas', 'hashtag']" /></label>
        <input type="text" id="check-no" class="form-control" v-model="formFields.checkNo" :placeholder="$t('che_no')"
          autocomplete="new-password" required="required">
      </div>
      <a id="" class="link" data-bs-toggle="modal" data-bs-target="#forgetCodeModal">نسيت رمز التحقق</a>
      <button type="submit" class="btn btn-primary w-100 my-1">
        <font-awesome-icon :icon="['fas', 'magnifying-glass']" /> {{ $t("inquiry") }}
      </button>
    </form>
    <div class="text-center">
      <a id="new-app-btn" @click="$parent.initNewModal"  class="link" >طلب جديد</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignForm",
  props: {
    formFields: Object,
  }
};
</script>
